import React, { useContext } from 'react'
const user = {
    authenticated: false,
    login: () => {}
}
export const AuthContext = React.createContext(user);
export const useAuthContext = () => (useContext(AuthContext)) 
